// src/pages/SignupSuccess.js

import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from 'react-router-dom';

const SignupSuccess = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'grey.100',
                p: 2
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, md: 5 },
                    maxWidth: 500,
                    textAlign: 'center',
                    borderRadius: 2
                }}
            >
                <CheckCircleOutlineIcon
                    sx={{ fontSize: 80, color: 'success.main', mb: 2 }}
                />
                
                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                    Welcome to SavvaiEdge!
                </Typography>
                
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    Your 14-day free trial has started
                </Typography>
                
                <Box sx={{ my: 4, p: 3, bgcolor: 'primary.50', borderRadius: 2, border: '1px solid', borderColor: 'primary.200' }}>
                    <EmailIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                    <Typography variant="body1" fontWeight="medium" gutterBottom>
                        Check your email
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        We've sent you an email with a link to set your password.
                        Once you've set your password, you can log in and start using SavvaiEdge.
                    </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Didn't receive the email? Check your spam folder or contact us at{' '}
                    <a href="mailto:support@savvai.ai">support@savvai.ai</a>
                </Typography>
            </Paper>
        </Box>
    );
};

export default SignupSuccess;